export default {
  CONNECT_SITE: '@WS/CONNECT_SITE',
  CREATE_PAGE_FROM_TEMPLATE: '@WS/CREATE_PAGE_FROM_TEMPLATE',
  CREATE_PAGE: '@WS/CREATE_PAGE',
  COPY_PAGE: '@WS/COPY_PAGE',
  DELETE_PAGE: '@WS/DELETE_PAGE',
  INITIALIZE_BLOCK: '@WS/INITIALIZE_BLOCK',
  SET_ACTIVE_PAGE: '@WS/SET_ACTIVE_PAGE',
  SET_PAGES_IN_NAVIGATION: '@WS/SET_PAGES_IN_NAVIGATION',
  SET_HOME_PAGE: '@WS/SET_HOME_PAGE',
  SET_HTML_CHECKPOINT: '@WS/SET_HTML_CHECKPOINT',
  SET_OWNER_ID: '@WS/SET_OWNER_ID',
  SET_PAGE_HTML: '@WS/SET_PAGE_HTML',
  SET_PAGE_USED_BLOCKS: '@WS/SET_PAGE_USED_BLOCKS',
  SET_SESSION: '@WS/SET_SESSION',
  SET_SETTINGS: '@WS/SET_SETTINGS',
  SET_SITE_ID: '@WS/SET_SITE_ID',
  SET_SITE_NAME: '@WS/SET_SITE_NAME',
  SET_SITE_PROPERTIES: '@WS/SET_SITE_PROPERTIES',
  SET_SITE_PROPERTY: '@WS/SET_SITE_PROPERTY',
  SET_MULTILINGUAL_PROPERTY: '@WS/SET_MULTILINGUAL_PROPERTY',
  UPDATE_SETTINGS: '@WS/UPDATE_SETTINGS',
  UPDATE_PAGE_SETTINGS: '@WS/UPDATE_PAGE_SETTINGS',
  SET_META_TRANSLATIONS: '@WS/SET_META_TRANSLATIONS',
  SET_PAGES: '@WS/SET_PAGES',
  SET_SITE_PROGRESS_CHECKLIST: '@WS/SET_SITE_PROGRESS_CHECKLIST',
  SET_UPDATED_AT: '@WS/SET_UPDATED_AT',
  SET_LAST_APPLIED_MIGRATION_ID: '@WS/SET_LAST_APPLIED_MIGRATION_ID',
  SET_CLEAN_URL_ENABLED: '@WS/SET_CLEAN_URL_ENABLED',
  EXPORT_SITE: '@WS/EXPORT_SITE',
  SET_REDIRECTS: '@WS/SET_REDIRECTS',
  UPDATE_REDIRECTS: '@WS/UPDATE_REDIRECTS',
  SET_INTEGRATIONS: '@WS/SET_INTEGRATIONS',
  UPDATE_INTEGRATIONS: '@WS/UPDATE_INTEGRATIONS',
  RELOAD_SITE_META: '@WS/RELOAD_SITE_META',
  ADD_FOLDER: '@WS/ADD_FOLDER',
  DELETE_FOLDER: '@WS/DELETE_FOLDER',
  RENAME_FOLDER: '@WS/RENAME_FOLDER',
  MOVE_TO_FOLDER: '@WS/MOVE_TO_FOLDER',
  ADD_BINDING: '@WS/ADD_BINDING',
  UPDATE_BINDING: '@WS/UPDATE_BINDING',
  REMOVE_BINDING: '@WS/REMOVE_BINDING',
};
